// extracted by extract-css-chunks-webpack-plugin
module.exports = {"carouselStep":"EzOAcZ","number":"_1DZF_A","stepTitle":"_2xqZRU","image":"_2eOFy2","text":"_1AT8c-","hasIcon":"_3iFYK4","iconWrapper":"_3W27W3"};